import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const editable = (el) => el?.closest?.("input, textarea, [contenteditable='true']");

// Blocks right-click, image dragging and long-press save for everyone except staff
export const ContentProtection = () => {
  const { user } = useAuth();
  const staff = !!user && (user.role === "admin" || user.role === "moderator");
  useEffect(() => {
    if (staff) return undefined;
    const onMenu = (e) => { if (!editable(e.target)) e.preventDefault(); };
    const onDrag = (e) => { if (e.target?.tagName === "IMG") e.preventDefault(); };
    document.addEventListener("contextmenu", onMenu);
    document.addEventListener("dragstart", onDrag);
    document.body.classList.add("cp-protect");
    return () => {
      document.removeEventListener("contextmenu", onMenu);
      document.removeEventListener("dragstart", onDrag);
      document.body.classList.remove("cp-protect");
    };
  }, [staff]);
  return null;
};
